import React from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import clsx from 'clsx'
import {checkIsActive, KTSVG} from '../../../helpers'

type Props = {
  to: string
  id: string
  className: string
  linkClass: string
  title: string
  icon?: string
}

const ToggleItem: React.FC<Props> = ({
  to,
  id,
  title,
  className,
  linkClass,
  icon,
}) => {
  const {pathname} = useLocation()
  const iconCheck = icon ? <i className={icon}></i> : "";
  // const hrefCheck = id ? "" : {to};

  return (
    <li className={className} id={id} data-url={to}>
      <a className={linkClass} href={id ? "" : to} target="_blank">
        {iconCheck}
        <p className="font-medium-2 mt-25 mb-50">{title}</p>
      </a>
    </li>
  )
}

export {ToggleItem}
